import { render, staticRenderFns } from "./PuzzlePage.vue?vue&type=template&id=2245b446&scoped=true&"
import script from "./PuzzlePage.vue?vue&type=script&lang=js&"
export * from "./PuzzlePage.vue?vue&type=script&lang=js&"
import style0 from "./PuzzlePage.vue?vue&type=style&index=0&id=2245b446&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245b446",
  null
  
)

export default component.exports